var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1009)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9064 4.01038C12.8647 3.22913 11.5064 3 10 3C5.10998 3 1.146 6.49371 1.146 10.5208C1.146 14.5479 5.63097 17.8125 10.521 17.8125C13.1596 17.8125 11.7635 15.1537 13.3856 13.6458C14.7697 12.3591 18.8543 12.8645 18.8543 10.5208C18.8543 9.12504 18.5939 7.91663 17.5522 6.7125",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.521 10.7812L19.1147 2.1875",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 6.75,
    r: 1.25,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.75,
    cy: 8.25,
    r: 1.25,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.25,
    cy: 12.25,
    rx: 1.25,
    ry: 1.25,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.77d06a83.svg";
export { ForwardRef as ReactComponent };